import { ClientConfigProductName } from '@frontend/vanilla/core';

import { clientConfigAppGuard, productUnderMaintenanceGuard } from '../guards';
import { RoutesConfig } from './routes-config';

const routes: RoutesConfig = {
    routes: [
        {
            path: 'myaccount',
            // @TODO handle web elements
            // eslint-disable-next-line @nx/enforce-module-boundaries
            loadChildren: () => import('@frontend/myaccount/entrypoint-lib').then((t) => t.MY_ACCOUNT_ROUTES),
            canMatch: [clientConfigAppGuard],
            canActivate: [productUnderMaintenanceGuard],
            data: { product: ClientConfigProductName.PORTAL },
        },
    ],
};

export default routes;
